import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import heroImage from "../Media/scene.jpg";
import collabImage from "../Media/background.jpg";
import "./Home.scss";

const offerings = [
  {
    title: "Networking",
    body: "Connect with businesses, clients, and partners across Australia, New Zealand and Egypt.",
  },
  {
    title: "Resources",
    body: "Access industry reports, leadership programs, and member-only tools.",
  },
  {
    title: "Advocacy",
    body: "We advocate for policies that support local and international businesses.",
  },
  {
    title: "Exposure",
    body: "Grow your brand through our events, publications and marketing platforms.",
  },
];

const Home = () => {
  return (
    <>
      <NavBar />
      <main className="home">
        <header className="home__hero">
          <div className="container home__heroInner">
            <div className="home__heroText">
              <span className="eyebrow">Chamber of Commerce &amp; Cultural Exchange</span>
              <h1 className="section-heading">
                Welcome to ANZEG Institute
              </h1>
              <p className="lede">
                Empowering international businesses through advocacy,
                networking, and resources between Australia, New Zealand and
                Egypt.
              </p>
              <Link to="/events" className="btn btn--filled">View Upcoming Events</Link>
            </div>
            <div className="home__heroImage">
              <img src={heroImage} alt="Sydney Harbour Bridge and the Rocks, Australia" />
            </div>
          </div>
        </header>

        <section className="home__split">
          <div className="container home__splitInner">
            <div className="home__splitText">
              <span className="eyebrow">About</span>
              <h2 className="section-heading section-heading--sm">About ANZEG Institute</h2>
              <p className="lede">
                The ANZEG Institute Chamber of Commerce is dedicated to
                fostering the growth and success of businesses within the
                local community and beyond. Our mission is to provide
                essential resources, networking opportunities, and advocacy
                to help businesses thrive.
              </p>
            </div>
            <div className="home__splitImage">
              <img src={collabImage} alt="ANZEG members at the Australian Embassy in Cairo" />
            </div>
          </div>
        </section>

        <section className="home__offer">
          <div className="container">
            <span className="eyebrow">What We Offer</span>
            <h2 className="section-heading section-heading--sm">Member Benefits</h2>
            <ul className="marker-list">
              {offerings.map((item) => (
                <li key={item.title}>
                  <strong>{item.title}:</strong> {item.body}
                </li>
              ))}
            </ul>
            <Link to="/membership" className="btn btn--filled">Join Now</Link>
          </div>
        </section>

        <section className="home__why">
          <div className="container">
            <span className="eyebrow">Why Join</span>
            <h2 className="section-heading section-heading--sm">Why ANZEG Institute?</h2>
            <p className="lede">
              Membership with ANZEG Institute is more than just being part of
              a business network, it's an investment in your business's
              future. Membership fees help fund critical services like
              industry research, leadership development programs, networking
              events, and advocacy campaigns. These initiatives are designed
              to empower members by providing them with the tools and
              connections they need to succeed in a competitive marketplace.
              By joining ANZEG Institute, you align your business with a
              trusted organization that advocates for your interests,
              connects you with opportunities, and offers a wealth of
              resources tailored to help you grow.
            </p>
            <Link to="/membership" className="btn btn--filled">Join Now</Link>
          </div>
        </section>

        <section className="home__grid">
          <div className="container home__gridInner">
            <div>
              <span className="eyebrow">Partnerships</span>
              <h3 className="section-heading section-heading--sm">Collaboration &amp; Sponsorships</h3>
              <p className="lede">
                ANZEG Institute partners with businesses and organizations
                for event sponsorships and joint ventures. Collaborate with
                us to enhance visibility, expand your reach, and engage with
                our diverse network. Our sponsorship opportunities allow your
                brand to stand out during high-profile events, such as our
                fundraising galas, networking mixers, and business
                workshops.
              </p>
            </div>
            <div>
              <span className="eyebrow">Funding</span>
              <h3 className="section-heading section-heading--sm">Research Grants &amp; Government Funding</h3>
              <p className="lede">
                ANZEG Institute supports businesses by providing access to
                government grants and financial support programs. We connect
                members with the resources necessary to ensure their
                businesses thrive and remain flexible. Discover available
                research grants and take advantage of funding opportunities
                that help ensure your business's longevity in today's
                competitive landscape.
              </p>
              <Link to="/membership" className="btn btn--link">Join Now &rarr;</Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Home;
